import type { IconCode } from "@components/Atoms/Icon/LucideIcon";
import t from "@ext/localization/locale/translate";
import { FLOAT_ALIGN_ICONS, NON_FLOATING_PARENTS } from "@ext/markdown/elements/float/edit/model/consts";
import type { FloatAlign } from "@ext/markdown/elements/float/edit/model/types";
import type { Node } from "@tiptap/pm/model";
import type { Editor } from "@tiptap/react";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger,
} from "@ui-kit/Dropdown";
import { GlassToolbarIcon, GlassToolbarTriggerChevron } from "@ui-kit/GlassToolbar";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";

const FloatActions = ({ node, editor, getPos }: { node: Node; editor: Editor; getPos: () => number }) => {
	const float: FloatAlign = node.attrs.float || "center";
	const tooltip = t("editor.float.name");

	if (NON_FLOATING_PARENTS.includes(editor.state.doc.resolve(getPos()).parent.type.name)) return null;

	const setFloat = (align: FloatAlign) => {
		editor.commands.setFloat(getPos(), node.type, align);
	};

	return (
		<DropdownMenu>
			<Tooltip>
				<TooltipTrigger asChild>
					<DropdownMenuTrigger asChild>
						<GlassToolbarTriggerChevron aria-label={tooltip}>
							<GlassToolbarIcon icon={FLOAT_ALIGN_ICONS[float] as IconCode} />
						</GlassToolbarTriggerChevron>
					</DropdownMenuTrigger>
				</TooltipTrigger>
				<TooltipContent sideOffset={2}>{tooltip}</TooltipContent>
			</Tooltip>
			<DropdownMenuContent>
				<DropdownMenuRadioGroup onValueChange={setFloat} value={float}>
					<DropdownMenuRadioItem value="left">{t(`editor.float.left`)}</DropdownMenuRadioItem>
					<DropdownMenuRadioItem value="center">{t(`editor.float.center`)}</DropdownMenuRadioItem>
					<DropdownMenuRadioItem value="right">{t(`editor.float.right`)}</DropdownMenuRadioItem>
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default FloatActions;
